import { TextWidth, TextWidthExtended } from '@ta-interaktiv/react-disco-grid'
import React from 'react'
import styled from 'styled-components'

export const TrickTwo = () => {
  return (
    <>
      {/* <TextWidth>
        <Title>
          KI-Objekterkennung lässt sich durch das Verändern weniger Pixel
          täuschen
        </Title>
      </TextWidth> */}
      <TextWidth>
        <StyledTrick>
          <LabelRow className='first'>
            <div>Orginalbild</div>
            <div className='tt'>Veränderung</div>
            <div>Falsch erkannt</div>
          </LabelRow>
          <ImageContainer>
            <img src={require('./images/trick_1_1.jpg')} />
            <img src={require('./images/trick_1_2.jpg')} />
            <img src={require('./images/trick_1_3.jpg')} />
          </ImageContainer>
          <LabelRow>
            <div>Schulbus</div>
            <div></div>
            <div>Vogel Strauss</div>
          </LabelRow>
          <ImageContainer>
            <img src={require('./images/trick_2_1.jpg')} />
            <img src={require('./images/trick_2_2.jpg')} />
            <img src={require('./images/trick_2_3.jpg')} />
          </ImageContainer>
          <LabelRow>
            <div>Seifenspender</div>
            <div></div>
            <div>Vogel Strauss</div>
          </LabelRow>
          <ImageContainer>
            <img src={require('./images/trick_3_1.jpg')} />
            <img src={require('./images/trick_3_2.jpg')} />
            <img src={require('./images/trick_3_3.jpg')} />
          </ImageContainer>
          <LabelRow>
            <div>Gottesanbeterin</div>
            <div></div>
            <div>Vogel Strauss</div>
          </LabelRow>
          <ImageContainer>
            <img src={require('./images/trick_4_1.jpg')} />
            <img src={require('./images/trick_4_2.jpg')} />
            <img src={require('./images/trick_4_3.jpg')} />
          </ImageContainer>
          <LabelRow>
            <div>Hund</div>
            <div></div>
            <div>Vogel Strauss</div>
          </LabelRow>        </StyledTrick>
      </TextWidth>
      <TextWidth>
        <Source>
          Quelle:{" "}
          <a href='https://vitalab.github.io/article/2021/03/05/IntriguingProperties.html'>
            Intriguing properties of neural networks, Christian Szegedy et al.
          </a>
        </Source>
      </TextWidth>
    </>
  )
}

const LabelRow = styled.div`
  flex: 0 0 100%;
  display: flex;
  font-family: var(--font-sans-serif);
  font-size: 12px;
  font-weight: 400;
  line-height: 1.1em;
  &.first{
    font-weight: 700; font-size: 15px;    
  }
  div {
    flex: 0 0 calc(33%);
    text-align: center;
    display: flex;

    justify-content: center;
  }
`
const Title = styled.div`
  flex: 0 0 100%;
  font-size: 18px;
  font-weight: 300;
  line-height: 1.3em;
  margin-bottom: 15px;
  font-family: var(--font-sans-serif);
`
const Source = styled.div`
  flex: 0 0 100%;
  font-size: 12px;
  color: var(--gray-3);
  font-family: var(--font-sans-serif);
  line-height: 1.4em;
  margin-bottom: 60px;
  a {
    color: var(--gray-3);
    text-decoration: underline;
  }
`

const StyledTrick = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  line-height: 1.1em !important;
  margin-bottom: 10px;
  overflow: hidden;
  max-width: 100%;

`
const ImageContainer = styled.div`
  flex: 0 0 calc(100%);
  display: flex;
  flex-wrap: wrap;
  line-height: 1.1em !important;
gap:5px;
  img {
    flex: 1 1 33.333%;
    max-width: calc(33% - 3px)
  }
  div {
    font-family: var(--font-sans-serif);
    font-size: 15px;
    line-height: 1.1em !important;
    flex: 0 0 33.3333%;
    font-weight: 400;
    margin-top: 6px;
    span {
      font-weight: 300;
      font-size: 12px;
      display: inline-block;
      width: 100%;
    }
  }
`
